import http from '../api/api'
import config from '../api/constants'

const verifyTransfer = async ({
  accountBranch,
  srcAccCcy,
  srcAccount,
  transferAmount,
  receiverMobileNo,
  serviceId,
  remarks,
  customerId,
}) => {
  try {
    const reqParams = {
      requestId: "BANKTOWALLETVERIFY",
      module: "BANKTOWALLET",
      extraData: "",
      invoiceNo: "",
      mobileNumber: receiverMobileNo,
      srcAccount: srcAccount,
      amount: transferAmount,
      serviceID: serviceId,
      remarks: remarks,
      srcAccCcy: srcAccCcy,
      paymentMode: "Mobile",
      srcAccBranch: accountBranch,
      // customerId: "",
    }
    const response = await http.post(config.apiRoute.VERIFY_SEND_TO_MOBILE, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const walletList = async () => {
  try {
    const reqParams = {
      requestId: "WALLETLIST",
    }
    const response = await http.post(config.apiRoute.GET_WALLET_LIST, reqParams)
    return response.data.walletList
  } catch (err) {
    throw err.response.data
  }
}

const confirmTransfer = async ({
  accountBranch,
  srcAccCcy,
  srcAccount,
  transferAmount,
  receiverMobileNo,
  serviceID,
  customerId,
  remarks,
  destinationAccount,
  destinationAccountName,
  destinationBranch,
  destinationCurrency,
  otp,
}) => {
  try {
    const reqParams = {
      requestId: "BANKTOWALLETCONFIRM",
      module: "BANKTOWALLET",
      extraData: "",
      invoiceNo: "",
      mobileNumber: receiverMobileNo,
      srcAccount: srcAccount,
      amount: transferAmount,
      serviceID: serviceID,
      // customerId:"",
      remarks: remarks,
      srcAccCcy: srcAccCcy,
      paymentMode: "Mobile",
      otp: otp,
      srcAccBranch: accountBranch,
    }
    const response = await http.post(config.apiRoute.CONFIRM_SEND_TO_MOBILE, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getTerms = async () => {
  try {
    const reqParams = {
      module: 'STM',
      requestId: 'OFFERS',
      userName: 'DEFAULT',
    }
    const response = await http.post(config.apiRoute.SEND_TO_MOBILE_GET_TERMS, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const SendToMobileService = {
  verifyTransfer,
  walletList,
  confirmTransfer,
  getTerms
}

export default SendToMobileService